// @flow

import {useEffect, useState} from 'react';
import queryString from 'query-string';
import {useLocation} from 'react-router-dom';
import {useActions} from '../../../../utils/globalStore';

import {useCardState} from '../../../checkout/utils';
import {actions as CheckoutActions} from '../../../checkout/duck';
import {actions as AccountActions} from '../duck';

export const useAddCardSuccess = (): boolean => {
  const location = useLocation();
  const [addCardSuccess, setAddCardSuccess] = useState<boolean>(false);
  const {checkCardState} = useActions(CheckoutActions);
  const {saveSubscriptionSetting} = useActions(AccountActions);
  const cardState = useCardState();
  const queryObject = queryString.parse(location.search);

  const addCard =
    queryObject.card_profile &&
    queryObject.setup_intent &&
    queryObject.setup_intent_client_secret &&
    queryObject.redirect_status === 'succeeded';

  useEffect(() => {
    if (addCard && !cardState && typeof queryObject.card_profile === 'string') {
      checkCardState({
        checkCardStateRequest: {cardProfileId: queryObject.card_profile},
      });
    }
  }, [addCard, cardState, checkCardState, queryObject.card_profile]);

  useEffect(() => {
    if (addCard && cardState) {
      setAddCardSuccess(true);
      saveSubscriptionSetting({
        accountConfigRequest: {
          automaticCharge: true,
        },
        reset: true,
      });
    }
  }, [addCard, cardState, saveSubscriptionSetting]);

  return addCardSuccess;
};

export function useChangePasswordAccount() {
  const changePassword = useActions(AccountActions.changeAccountPassword);

  return changePassword;
}
